import { apiClientes } from "../config/api";
import { Response } from "../interfaces/services/Response";
import { getTokenClientes } from "../Store/storages/AuthenticationStorage";

export const getTelefonesUteis = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Config/GetTelefonesUteis', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};